const defaultForms: any[] = 
[
    {
        "serviceType": "ifm",
        "DADA_VERSION": "DADA_VERSION",
        "switchId": "610887947",
        "protocolFormat": "DADA", 
        "originalLocale": "ur_PK",
        "sellerId": 6005267952910,
        "platform_product": true,
        "gpf_productNames": [],
        "isFromMtop": true,
        "dict": {
            "bulkEdit": "tr(data.bulkEdit.lazada)",
            "useSkuImageAsThumbnail": "We suggestion only upload one image only for each variation，due to variation images 2-8 have low traffic.",
            "requireSkuOrMainImages": "Image is missing. Please upload at least 1 image.",
            "skuImageLengthExceeded": "tr(data.skuImageLengthExceeded.lazada)",
            "requireFullSkuImages": "You must add all the variation images or leave all of them empty."
        },
        "id": 610887947,
        "value": {
            "render_tag": "9f7f3c4aab44f62d22361c293f50b6b4",
            "renderTimestamp": 1730917068628,
            "originalLocale": "ur_PK",
            "sellerId": 6005267952910,
            "beforeCatId": 48,
            "id": 610887947,
            "currencyCode": "PKR",
            "forbidden_tag": "1a680194f3c67896a805748ea538c06d"
        },
        "custom_sale_prop": true,
        "sellerMode": "MP2",
        "image": "DarazApp",
        "translateIgnoreFields": [
            "html"
        ],
        "currentLogonRole": "SELLER",
        "edit": false,
        "multiLangHtmlv2Gray": false,
        "optType": "switchCategory",
        "renderTimestamp": 1730917068628,
        "catId": 48,
        "gatewayUrlPrefix": "",
        "name": "global",
        "sellerBizType": "DARAZ",
        "uiType": "ProductRoute",
        "gpf_identity": "marketplace-item-100",
        "pdpLink": "null/products/i610887947.html",
        "currencyCode": "PKR",
        "Delivery_Option_sof": false
    },
    {
        "name": "dict",
        "dict": {
            "bulkEdit": "tr(data.bulkEdit.lazada)",
            "useSkuImageAsThumbnail": "We suggestion only upload one image only for each variation，due to variation images 2-8 have low traffic.",
            "requireSkuOrMainImages": "Image is missing. Please upload at least 1 image.",
            "skuImageLengthExceeded": "tr(data.skuImageLengthExceeded.lazada)",
            "requireFullSkuImages": "You must add all the variation images or leave all of them empty."
        },
        "group": "basic"
    },
    {
        "maxItems": 2,
        "visible": true,
        "longImageShow": false,
        "squareImageShow": true,
        "rule": {
            "minHeight": 330,
            "maxHeight": 5000,
            "minWidth": 330,
            "maxSize": 3145728,
            "minSize": 0,
            "ratios": [
                "1:1",
                "3:4"
            ],
            "tips": [
                {
                    "text": "1. Size: Less than 5MB.<br/>\n2. Supported formats: JPG, JPEG or PNG.<br/>\n3. The aspect ratio (W x H) must be 1:1.<br/>\n4. The minimum resolution is 330 x 330 pixels. (Recommended: 1000 x 1000 pixels).<br/>\n5. The background should be plain white (preferred) or show the real environment.<br/>\n6. Do not include watermarks, any forms of borders, or marketing copy in the picture."
                },
                {
                    "text": "1. Size: Less than 5MB.<br/>\n2. Supported formats: JPG, JPEG or PNG.<br/>\n3. The aspect ratio (W x H) must be 3:4.<br/>\n4. The minimum resolution is 750 x 1000 pixels. (Recommended: 750 x 1,000 pixels)<br/>\n5. The background should be plain white (preferred) or show the real environment.<br/>\n6. Do not include watermarks, any forms of borders, or marketing copy in the picture."
                }
            ],
            "accept": [
                "jpg",
                "png",
                "jpeg"
            ],
            "maxWidth": 5000
        },
        "label": "Buyer Promotion Image",
        "suggest": {
            "minHeight": 330,
            "maxHeight": 5000,
            "minWidth": 330,
            "maxWidth": 5000
        },
        "locale": {
            "heightNoLessThan": "Pictures height can't less than ${minHeight}px.",
            "uploadFromLocal": "Upload",
            "type": "marketImageLocaleModel",
            "uploadText": "Add Picture",
            "error": "Error",
            "uploadFailedTryAgain": "Pictures format don't meet the requirements or analysis failure please re-upload, or replacement other format of pictures.",
            "redundant": "Please don't repeat select the same pictures.",
            "fixedHeight": "You can only select height for ${fixedHeight}px of pictures.",
            "mediaSelect": "Media Center",
            "heightNoMoreThan": "Pictures height can't greater than ${maxHeight}px.",
            "viewExample": "See Example",
            "fixedSize": "You can only select size for${fixedWidth}x${fixedHeight} of pictures.",
            "tooSmall": "Pictures file can't be less than ${minSize}",
            "warning": "Warning",
            "uploadFromBank": "Media Center",
            "reachMaxMsg": "Most can only add ${maxItems} bed pictures.",
            "widthNoLessThan": "Picture width needs to be larger than $ {minWidth} px. If the size is right but you're still having troubles uploading, check if the picture format is following the requirements.",
            "fixedWidth": "You can only select width for ${fixedWidth} px of pictures.",
            "tooLarge": "Pictures file can't exceed ${maxSize}",
            "systemAbnormal": "System error. Please later try again.",
            "imageBank": "Pictures bank",
            "viewExampleTitle": "tr{viewExampleTitle@photo_bank}",
            "ratioIllegal": "Please upload length and width proportion for ${ratio} of pictures.",
            "noSizeInfo": "The picture you selected contains no sizing information. Please reselect.",
            "widthNoMoreThan": "Picture width can't exceed ${maxWidth}px.",
            "extIllegal": "Please upload the following type of photos: ${accept}"
        },
        "required": false,
        "uploadConfig": {
            "mediaLocalUpload": true,
            "dragable": true,
            "picUploadApi": "/item/utility/image/upload",
            "uploaderType": "fileBroker2",
            "multiple": true,
            "params": {
                "bizCode": "DARAZ_PK-itemposting",
                "scene": "wsproductImageRule"
            }
        },
        "showPromptImage": false,
        "allowEmpty": true,
        "name": "marketImages",
        "uiType": "marketImages",
        "showImageBankBtn": true,
        "promptImages": [
            "https://img.alicdn.com/tfs/TB1RuGzMxD1gK0jSZFsXXbldVXa-330-330.jpg",
            "https://img.alicdn.com/tfs/TB12Py0c8Bh1e4jSZFhXXcC9VXa-220-330.jpg"
        ],
        "imageBankConfig": {
            "dialogType": "dialog",
            "sendDataType": "url",
            "winInfo": {
                "width": 1016,
                "height": 678
            },
            "newMediaCenter": true,
            "disabled": false,
            "openTabUrl": false,
            "config": {
                "single": true,
                "hideBanner": true,
                "atoken": "temp",
                "specLimit": "750-3750,1000-5000",
                "active": "select",
                "height": 678
            },
            "url": "//shopdesign.aliexpress.com/finder/iframe/product_description/0"
        },
        "prompts": [
            "Square Image (Aspect Ratio 1:1)",
            "Long Image (Aspect ratio: 3:4)"
        ],
        "isOrder": false,
        "group": "basic",
        "info": {
            "help": "A buyer promotion image represents your product in various places, such as search result page, product recommendation page, etc. Having a buyer promotion image will inspire buyers to click on your product.",
            "top": "<div>1. A buyer promotion image represents your product in various places, such as search result page, product recommendation page, etc.</div><div>2. Having a buyer promotion image will inspire buyers to click on your product.</div>"
        }
    },
    {
        "checkNotice": {
            "method": "post",
            "url": "mtop.lazada.merchant.product.publish.async/?optType=titleBrandWarn"
        },
        "visible": true,
        "showCounter": true,
        "multiLanguage": {
            "dialog": {
                "inputConfig": {
                    "maxLength": 255
                },
                "action": {
                    "method": "post",
                    "url": "mtop.lazada.merchant.product.publish.async/?optType=multiLanguageTranslate"
                }
            },
            "iconType": "duoyuyan"
        },
        "label": "Product Name",
        "locale": {
            "dialogDesc": "This feature allows you to translate automatically, but you can edit manually",
            "edit": "Setup Multi-Languages",
            "ignore": "Ignore",
            "dialogTitle": "Setup Multi-Languages",
            "dialogCancel": "Cancel",
            "dialogOk": "Save",
            "dialogTranslate": "Translate",
            "type": "recommendMultiTitleInputLocale",
            "ourSuggestion": "Our Suggestions",
            "tips": "Multi-Languages hasn't been added for the edited content. Go to \"Setup Multi-Languages\" to synchronize.",
            "setLanguage": "Add Multi-Languages",
            "otherLanguage": "Other languages"
        },
        "required": true,
        "name": "title",
        "uiType": "multiLangInput",
        "titleSuggestion": {
            "method": "POST",
            "url": "mtop.lazada.merchant.product.publish.async/?optType=smartTitleAsyncOpt"
        },
        "placeholder": "Ex. Nikon Coolpix A300 Digital Camera",
        "illegalPatterns": [
            {
                "pattern": "[]",
                "message": "The input title contains Chinese."
            }
        ],
        "value": [
            {
                "isEditedByUser": false,
                "label": "English",
                "key": "en_PK"
            },
            {
                "isEditedByUser": false,
                "label": "Urdu",
                "key": "ur_PK"
            }
        ],
        "maxLength": 255,
        "hasLimitHint": true,
        "group": "basic",
        "info": {
            "help": "Use brand name and unique selling points of your product to boost searchability by up to 6x. For example: Adidas 100% Cotton Men's Sport T-Shirt.\nAvoid stacking irrelevant keywords as this will result in product suspension."
        }
    },
    {
        "maxItems": 8,
        "visible": true,
        "rule": {
            "maxSize": 3145728,
            "minSize": 0,
            "accept": [
                "jpg",
                "png",
                "jpeg"
            ]
        },
        "label": "Product Images",
        "suggest": {
            "minHeight": 330,
            "maxHeight": 5000,
            "iconType": "prompt",
            "minWidth": 330,
            "text": "Image not meeting requirements! <br /> \nA. Required aspect ratio: 1:1. Minimum pixel: 800X800 <br /> \nB. Required aspect ratio: 3:4. Minimum pixel: 750X1000 <br /> \nC. Do not add other information besides the product on the product image, such as watermark, psoriasis, etc.",
            "maxWidth": 5000
        },
        "locale": {
            "widthNoLessThan": "Picture width needs to be larger than $ {minWidth} px. If the size is right but you're still having troubles uploading, check if the picture format is following the requirements.",
            "heightNoLessThan": "Pictures height can't less than ${minHeight}px.",
            "fixedWidth": "You can only select width for ${fixedWidth} px of pictures.",
            "tooLarge": "Pictures file can't exceed ${maxSize}",
            "systemAbnormal": "System error. Please later try again.",
            "imageBank": "Pictures bank",
            "uploadFromLocal": "Upload",
            "type": "photoBankImages",
            "uploadText": "Add Picture",
            "error": "Error",
            "uploadFailedTryAgain": "Pictures format don't meet the requirements or analysis failure please re-upload, or replacement other format of pictures.",
            "redundant": "Please don't repeat select the same pictures.",
            "fixedHeight": "You can only select height for ${fixedHeight}px of pictures.",
            "confirm": "Confirm",
            "heightNoMoreThan": "Pictures height can't greater than ${maxHeight}px.",
            "fixedSize": "You can only select size for${fixedWidth}x${fixedHeight} of pictures.",
            "tooSmall": "Pictures file can't be less than ${minSize}",
            "ratioIllegal": "Please upload length and width proportion for ${ratio} of pictures.",
            "warning": "Warning",
            "uploadFromBank": "Media Center",
            "noSizeInfo": "The picture you selected contains no sizing information. Please reselect.",
            "widthNoMoreThan": "Picture width can't exceed ${maxWidth}px.",
            "extIllegal": "Please upload the following type of photos: ${accept}",
            "reachMaxMsg": "Most can only add ${maxItems} bed pictures."
        },
        "title": "Photo Bank",
        "required": true,
        "uploadConfig": {
            "mediaLocalUpload": true,
            "dragable": true,
            "picUploadApi": "/ops/image/upload",
            "uploaderType": "fileBroker2",
            "multiple": true,
            "params": {
                "bizCode": "DARAZ_PK-itemposting"
            }
        },
        "allowEmpty": true,
        "name": "mainImage",
        "uiType": "MainImage",
        "showImageBankBtn": true,
        "promptImages": [],
        "imageBankConfig": {
            "dialogType": "dialog",
            "sendDataType": "url",
            "winInfo": {
                "width": 1016,
                "height": 678
            },
            "newMediaCenter": true,
            "disabled": false,
            "openTabUrl": false,
            "config": {
                "single": false,
                "hideBanner": true,
                "atoken": "temp",
                "active": "select",
                "height": 678
            }
        },
        "prompts": [
            "Front",
            "Back",
            "Real shot",
            "Side view",
            "Close-up",
            "Close-up",
            "Close-up",
            "Close-up"
        ],
        "group": "base",
        "info": {
            "help": "Product images are the main images of your item. For some cases and categories, you can also upload variant level image below on Price & Stock section.<a href=\"https://university.lazada.co.id/course/learn?spm=lzd-university-id-pc.lzd-university-id-pc-course.module-list.6.307e1fd6RVNV3h&id=797&sid=327&type=article \">Click to view item image usage </a> <img src=\"https://img.alicdn.com/tfs/TB1MzAq4xD1gK0jSZFsXXbldVXa-240-109.png\" alt=\"test\" />",
            "top": "<div>1. This is the main image of your product page. Maximum 8 images can be uploaded.</div><div>2. Image size between 330x330 and 5000x5000 px. Max file size: 3 MB.</div><div>3. Obscene image is strictly prohibited.</div>"
        }
    },
    {
        "itemDirection": "ver",
        "visible": false,
        "name": "categorySuggest",
        "uiType": "RadioGroup",
        "label": "Category Suggestions",
        "locale": {
            "type": "categorySuggestLocaleModel",
            "content": "Changing category will not effect basic attributes such as 'Name', 'Brand', 'Description' or product ratings and performance history. However, some category-specific attributes may be removed.Any changes will not be final until you click \"Publish\". Do you still want to continue?"
        },
        "required": false,
        "group": "base"
    },
    {
        "itemDirection": "ver",
        "visible": false,
        "name": "imgCategorySuggest",
        "uiType": "RadioGroup",
        "label": "Category Suggestions",
        "required": false,
        "group": "base"
    },
    {
        "showCascade": true,
        "showRecently": true,
        "switchSubmitUrl": "mtop.lazada.merchant.product.publish.switch.submit/",
        "hasEdit": false,
        "showPath": true,
        "locale": {
            "cancel": "Cancel",
            "searchPlaceholder": "Type to Search",
            "noMatchingResult": "No data",
            "pathLabel": "Current selection:",
            "clear": "Clear",
            "cascadeSearchPlaceholder": "Keyword",
            "searchLabel": "Search",
            "type": "lazadaCategoryPath",
            "tips": "<div style=\"margin-top:-10px\">Don't have a suitable category option? <a target=\"_blank\" href=\"https://global-cpv.aliexpress.com/report/categoryIssueReport.htm?spm=5261.ae_offer_item_post_product.0.0.6b7bbdf9ARJDBv&channelId=5\">Click here to submit</a> </br>Haven't applied for category rights yet? <a target=\"_blank\" href=\"https://userauth.aliexpress.com/invite/myPermissionList.htm?type=category\">Click here to apply</a></div>",
            "content": "Changing category will not effect basic attributes such as 'Name', 'Brand', 'Description' or product ratings and performance history. However, some category-specific attributes may be removed.Any changes will not be final until you click \"Publish\". Do you still want to continue?",
            "historyPlaceholder": "Recently used",
            "recentlyUse": "Recently used",
            "ok": "Confirm",
            "toChooseCategory": "Search Category"
        },
        "required": true,
        "historyPlaceholder": "Recently used",
        "showSearch": false,
        "categorySearchUrl": "mtop.lazada.merchant.product.publish.async/?optType=categorySearchAsyncOpt",
        "searchUrl": "mtop.lazada.merchant.product.publish.category.async/?optType=searchCategory",
        "syncSearch": false,
        "value": {
            "path": [
                "Mobiles & Tablets",
                "Gadgets"
            ],
            "spell": "Gadgets",
            "idpath": [
                2,
                48
            ],
            "name": "Gadgets",
            "disabled": false,
            "id": 48,
            "leaf": true
        },
        "group": "base",
        "renderUrl": "mtop.lazada.merchant.product.publish.render.v1/",
        "maxItems": 1,
        "visible": true,
        "currentPath": [],
        "label": "Category",
        "filters": [],
        "openUrl": false,
        "realTime": true,
        "historyUrl": "mtop.lazada.merchant.product.publish.category.async/?optType=queryCategoryHistory",
        "selectLeaf": true,
        "categorySearchPlaceHolder": "Search Category ",
        "showFilter": false,
        "showHistory": false,
        "name": "categoryPath",
        "uiType": "catInput",
        "catCascadeUrl": "mtop.lazada.merchant.product.publish.category.async/?optType=queryCategoryCascade",
        "selectParent": false,
        "selectedCats": []
    },
    {
        "visible": true,
        "readonly": false,
        "hasMediaCenter": true,
        "name": "newVideo",
        "rule": {
            "minSize": 480,
            "maxSize": 102400,
            "maxLength": 60,
            "accept": [
                "video/mp4"
            ]
        },
        "label": "Video",
        "locale": {
            "upload": "<li>Min size: 480x480 px. max video length: 60 seconds. max file size: 100MB.</li><li>Supported Format: mp4</li><li>New Video might take up to 36 hrs to be approved</li>",
            "type": "uploadLocaleModel"
        },
        "dataSource": [
            {
                "label": "Upload Video",
                "value": "uploadVideo"
            },
            {
                "label": "Youtube Link",
                "value": "youtubeLink"
            },
            {
                "label": "Media Center",
                "value": "mediaCenter"
            }
        ],
        "group": "base",
        "info": {
            "help": "Customers who viewed a real product video is more likely to buy an item. Learn more on how to upload your video <a href=\"https://university.lazada.sg/course/learn?spm=lzd-university-sg-pc.lzd-university-sg-pc-list.0.0.6090395aeMLGIF&id=13963&type=article\" target=\"_blank\">here</a>"
        }
    },
    {
        "visible": true,
        "name": "catProperty",
        "uiType": "catProp",
        "label": "Product Attributes",
        "locale": {
            "clear": "Clear all",
            "type": "catPropertyLocaleModel"
        },
        "hideSecondaryProp": true,
        "dataSource": [
            {
                "important": false,
                "async": {
                    "method": "POST",
                    "searchUrl": "mtop.lazada.merchant.product.publish.async/?optType=searchBrandAsyncOpt",
                    "queryBrandHistoryUrl": "mtop.lazada.merchant.product.publish.async/?optType=queryBrandHistoryOpt"
                },
                "name": "p-20000",
                "uiType": "searchSelect",
                "label": "Brand",
                "placeholder": "Select",
                "locale": {
                    "brandRecentlyUse": "Recently used:",
                    "or": "or",
                    "addNewBrand": "<a href=\"/portal/apps/setting/brand_v2/detail\" target=\"_blank\">Add New Brand</a>.",
                    "noBrand": "No Brand",
                    "applyNoBrand": "Set as No Brand",
                    "type": "newBrandPropLocaleModel"
                },
                "required": true,
                "group": "base",
                "info": {
                    "help": [
                        "Brand of the product",
                        "Search your brand by typing a keyword. If your brand is not on the list, please <a href=\"/portal/apps/setting/brand_v2/detail\" target=\"_blank\">Submit New Brand</a>"
                    ]
                },
                "allowImageUpload": true
            },
            {
                "important": false,
                "name": "p-30128",
                "uiType": "input",
                "label": "Model",
                "placeholder": "Input here",
                "illegalPatterns": [
                    {
                        "pattern": "[\\u4e00-\\u9fa5]",
                        "message": "No special characters allowed for custom properties e.g. #, <, >, etc"
                    }
                ],
                "secondaryProp": true,
                "locale": {
                    "searchPlaceholder": "Search",
                    "cancel": "Cancel",
                    "selectAll": "Select All",
                    "edit": "Modify",
                    "hasSelect": "Selected",
                    "dialogTitle": "Select",
                    "type": "globalItemPropLocaleModel",
                    "ok": "Confirm",
                    "setting": "Settings"
                },
                "required": false,
                "group": "base",
                "info": {},
                "allowImageUpload": true
            },
            // {
            //     "multiple": true,
            //     "label": "Color Family",
            //     "locale": {
            //         "searchPlaceholder": "Search",
            //         "cancel": "Cancel",
            //         "selectAll": "Select All",
            //         "edit": "Modify",
            //         "hasSelect": "Selected",
            //         "dialogTitle": "Select",
            //         "type": "globalItemPropLocaleModel",
            //         "ok": "Confirm",
            //         "setting": "Settings"
            //     },
            //     "required": false,
            //     "important": false,
            //     "name": "p-30129",
            //     "uiType": "combobox",
            //     "placeholder": "Please Input or select option",
            //     "illegalPatterns": [
            //         {
            //             "pattern": "[\\u4e00-\\u9fa5]",
            //             "message": "No special characters allowed for custom properties e.g. #, <, >, etc"
            //         }
            //     ],
            //     "secondaryProp": true,
            //     "dataSource": [
            //         {
            //             "text": "Black",
            //             "value": 3731
            //         },
            //         {
            //             "text": "Beige",
            //             "value": 3737
            //         },
            //         {
            //             "text": "Blue",
            //             "value": 3732
            //         },
            //         {
            //             "text": "Brown",
            //             "value": 3733
            //         },
            //         {
            //             "text": "Gold",
            //             "value": 3734
            //         },
            //         {
            //             "text": "Green",
            //             "value": 3736
            //         },
            //         {
            //             "text": "Grey",
            //             "value": 3735
            //         },
            //         {
            //             "text": "Multicolor",
            //             "value": 3759
            //         },
            //         {
            //             "text": "Olive",
            //             "value": 3764
            //         },
            //         {
            //             "text": "Orange",
            //             "value": 3738
            //         },
            //         {
            //             "text": "Pink",
            //             "value": 3739
            //         },
            //         {
            //             "text": "Purple",
            //             "value": 3740
            //         },
            //         {
            //             "text": "Red",
            //             "value": 1577
            //         },
            //         {
            //             "text": "Silver",
            //             "value": 3741
            //         },
            //         {
            //             "text": "Turquoise",
            //             "value": 3742
            //         },
            //         {
            //             "text": "Violet",
            //             "value": 3751
            //         },
            //         {
            //             "text": "White",
            //             "value": 3743
            //         },
            //         {
            //             "text": "Yellow",
            //             "value": 3744
            //         },
            //         {
            //             "text": "Clear",
            //             "value": 3750
            //         },
            //         {
            //             "text": "Apricot",
            //             "value": 3749
            //         },
            //         {
            //             "text": "Aqua",
            //             "value": 3748
            //         },
            //         {
            //             "text": "Avocado",
            //             "value": 3747
            //         },
            //         {
            //             "text": "Blueberry",
            //             "value": 3745
            //         },
            //         {
            //             "text": "Blush Pink",
            //             "value": 3752
            //         },
            //         {
            //             "text": "Bronze",
            //             "value": 3753
            //         },
            //         {
            //             "text": "Charcoal",
            //             "value": 3770
            //         },
            //         {
            //             "text": "Cherry",
            //             "value": 3769
            //         },
            //         {
            //             "text": "Chestnut",
            //             "value": 3768
            //         },
            //         {
            //             "text": "Chili Red",
            //             "value": 3766
            //         },
            //         {
            //             "text": "Chocolate",
            //             "value": 3746
            //         },
            //         {
            //             "text": "Cinnamon",
            //             "value": 3765
            //         },
            //         {
            //             "text": "Coffee",
            //             "value": 3755
            //         },
            //         {
            //             "text": "Cream",
            //             "value": 3763
            //         },
            //         {
            //             "text": "Floral",
            //             "value": 3756
            //         },
            //         {
            //             "text": "Galaxy",
            //             "value": 3771
            //         },
            //         {
            //             "text": "Hotpink",
            //             "value": 3772
            //         },
            //         {
            //             "text": "Ivory",
            //             "value": 3767
            //         },
            //         {
            //             "text": "Jade",
            //             "value": 3761
            //         },
            //         {
            //             "text": "Khaki",
            //             "value": 3762
            //         },
            //         {
            //             "text": "Lavender",
            //             "value": 3760
            //         },
            //         {
            //             "text": "Magenta",
            //             "value": 3758
            //         },
            //         {
            //             "text": "Mahogany",
            //             "value": 3757
            //         },
            //         {
            //             "text": "Mango",
            //             "value": 3754
            //         },
            //         {
            //             "text": "Maroon",
            //             "value": 1235
            //         },
            //         {
            //             "text": "Neon",
            //             "value": 3823
            //         },
            //         {
            //             "text": "Tan",
            //             "value": 3774
            //         },
            //         {
            //             "text": "Watermelon red",
            //             "value": 3813
            //         },
            //         {
            //             "text": "Lake Blue",
            //             "value": 3791
            //         },
            //         {
            //             "text": "Lemon Yellow",
            //             "value": 3803
            //         },
            //         {
            //             "text": "Army Green",
            //             "value": 3780
            //         },
            //         {
            //             "text": "Rose",
            //             "value": 3779
            //         },
            //         {
            //             "text": "Dark blue",
            //             "value": 3775
            //         },
            //         {
            //             "text": "Camel",
            //             "value": 3773
            //         },
            //         {
            //             "text": "Burgundy",
            //             "value": 3809
            //         },
            //         {
            //             "text": "Light blue",
            //             "value": 3808
            //         },
            //         {
            //             "text": "Champagne",
            //             "value": 3781
            //         },
            //         {
            //             "text": "Light green",
            //             "value": 3790
            //         },
            //         {
            //             "text": "Dark Brown",
            //             "value": 3800
            //         },
            //         {
            //             "text": "Navy Blue",
            //             "value": 3785
            //         },
            //         {
            //             "text": "Light Grey",
            //             "value": 3831
            //         },
            //         {
            //             "text": "Off White",
            //             "value": 3784
            //         },
            //         {
            //             "text": "Light yellow",
            //             "value": 3776
            //         },
            //         {
            //             "text": "Emerald Green",
            //             "value": 3786
            //         },
            //         {
            //             "text": "Fluorescent Green",
            //             "value": 3819
            //         },
            //         {
            //             "text": "Fluorescent Yellow",
            //             "value": 3797
            //         },
            //         {
            //             "text": "Deep green",
            //             "value": 3794
            //         },
            //         {
            //             "text": "Not Specified",
            //             "value": 2475
            //         },
            //         {
            //             "text": "Neutral",
            //             "value": 12645
            //         },
            //         {
            //             "text": "Cyan",
            //             "value": 13987
            //         },
            //         {
            //             "text": "Multi",
            //             "value": 19454
            //         },
            //         {
            //             "text": "Matte Black",
            //             "value": 20882
            //         },
            //         {
            //             "text": "Rose Gold",
            //             "value": 21772
            //         },
            //         {
            //             "text": "Peach",
            //             "value": 23166
            //         },
            //         {
            //             "text": "Mint",
            //             "value": 23347
            //         },
            //         {
            //             "text": "Peanut",
            //             "value": 23432
            //         },
            //         {
            //             "text": "Rainbow",
            //             "value": 27417
            //         },
            //         {
            //             "text": "Deep Blue",
            //             "value": 33410
            //         },
            //         {
            //             "text": "Golden",
            //             "value": 53757
            //         },
            //         {
            //             "text": "Jet Black",
            //             "value": 64229
            //         },
            //         {
            //             "text": "…",
            //             "value": 66038
            //         },
            //         {
            //             "text": "Dark Grey",
            //             "value": 73575
            //         },
            //         {
            //             "text": "Fuchsia",
            //             "value": 73846
            //         },
            //         {
            //             "text": "Blue Gray",
            //             "value": 73848
            //         },
            //         {
            //             "text": "Orchid Grey",
            //             "value": 76113
            //         },
            //         {
            //             "text": "Sand",
            //             "value": 103073
            //         },
            //         {
            //             "text": "Teal",
            //             "value": 122693
            //         },
            //         {
            //             "text": "Cacao",
            //             "value": 143163
            //         },
            //         {
            //             "text": "Wither Black",
            //             "value": 143164
            //         },
            //         {
            //             "text": "Sand Brown",
            //             "value": 143165
            //         },
            //         {
            //             "text": "Dark Ash",
            //             "value": 143166
            //         },
            //         {
            //             "text": "Deep Gray",
            //             "value": 143167
            //         },
            //         {
            //             "text": "Champagne Pink",
            //             "value": 143168
            //         },
            //         {
            //             "text": "Light Ash",
            //             "value": 143169
            //         },
            //         {
            //             "text": "Antique White",
            //             "value": 143170
            //         },
            //         {
            //             "text": "Ochre Brown",
            //             "value": 143171
            //         },
            //         {
            //             "text": "Glitter Black",
            //             "value": 143176
            //         },
            //         {
            //             "text": "Glitter Blue",
            //             "value": 143177
            //         },
            //         {
            //             "text": "Metallic Cherry",
            //             "value": 143178
            //         },
            //         {
            //             "text": "Metallic Lilac",
            //             "value": 143179
            //         },
            //         {
            //             "text": "Metallic Teal",
            //             "value": 143180
            //         },
            //         {
            //             "text": "Space Grey",
            //             "value": 143250
            //         },
            //         {
            //             "text": "Light Black",
            //             "value": 147416
            //         },
            //         {
            //             "text": "Rose Red",
            //             "value": 147417
            //         },
            //         {
            //             "text": "Deep Black",
            //             "value": 147418
            //         },
            //         {
            //             "text": "Glow Yellow",
            //             "value": 147419
            //         },
            //         {
            //             "text": "Neo Bright",
            //             "value": 147420
            //         },
            //         {
            //             "text": "Neutrals",
            //             "value": 202907
            //         },
            //         {
            //             "text": "Multicolour",
            //             "value": 202908
            //         },
            //         {
            //             "text": "Blonde",
            //             "value": 202909
            //         }
            //     ],
            //     "group": "base",
            //     "info": {
            //         "help": [
            //             "This color is used for filtering on the category pages of Daraz. Customers will be able to find products faster by selecting the color filter of their choice.",
            //             "<a href=\"https://xform.daraz.pk/form/show.do\" target=\"_blank\">Please click here to request new values</a>"
            //         ]
            //     },
            //     "allowImageUpload": true
            // },
            // {
            //     "label": "Express Delivery",
            //     "required": false,
            //     "important": false,
            //     "async": {
            //         "matchUrl": "mtop.lazada.merchant.product.publish.async/?optType=catPropRenderAsyncOpt&catId=48"
            //     },
            //     "showSearch": true,
            //     "name": "p-40920",
            //     "uiType": "select",
            //     "placeholder": "Select",
            //     "illegalPatterns": [
            //         {
            //             "pattern": "[\\u4e00-\\u9fa5]",
            //             "message": "No special characters allowed for custom properties e.g. #, <, >, etc"
            //         }
            //     ],
            //     "secondaryProp": true,
            //     "dataSource": [
            //         {
            //             "text": "Lahore",
            //             "value": 196640
            //         },
            //         {
            //             "text": "Islamabad",
            //             "value": 196641
            //         },
            //         {
            //             "text": "Multan",
            //             "value": 271636
            //         },
            //         {
            //             "text": "Karachi",
            //             "value": 271637
            //         },
            //         {
            //             "text": "Quetta",
            //             "value": 271638
            //         },
            //         {
            //             "text": "Hyderabad",
            //             "value": 271639
            //         },
            //         {
            //             "text": "Peshawar",
            //             "value": 271642
            //         },
            //         {
            //             "text": "Okara",
            //             "value": 271643
            //         },
            //         {
            //             "text": "Gujranwala",
            //             "value": 271645
            //         },
            //         {
            //             "text": "Sialkot",
            //             "value": 271650
            //         },
            //         {
            //             "text": "Faisalabad",
            //             "value": 271659
            //         },
            //         {
            //             "text": "Abbottabad",
            //             "value": 121196824
            //         },
            //         {
            //             "text": "Bahawalpur",
            //             "value": 121196825
            //         },
            //         {
            //             "text": "Gujrat",
            //             "value": 121196826
            //         },
            //         {
            //             "text": "Jhelum",
            //             "value": 121196827
            //         },
            //         {
            //             "text": "Sahiwal",
            //             "value": 121196828
            //         },
            //         {
            //             "text": "Sargodha",
            //             "value": 121196829
            //         },
            //         {
            //             "text": "Sheikhupura",
            //             "value": 121196830
            //         },
            //         {
            //             "text": "Sukkur",
            //             "value": 121196831
            //         }
            //     ],
            //     "group": "base",
            //     "info": {
            //         "help": [
            //             "Express delivery",
            //             "<a href=\"https://xform.daraz.pk/form/show.do\" target=\"_blank\">Please click here to request new values</a>"
            //         ]
            //     },
            //     "allowImageUpload": true
            // }
        ],
        "value": {},
        "required": true,
        "group": "base",
        "info": {
            "help": "Product specification determines buyers' understanding of product features and their purchase decision. Fill in both key and supporting specification attributes to increase your product exposure.",
            "top": "Boost your item's searchability by filling-up the Key Product Information marked with KEY. The more you fill-up, the easier for buyers to find your product."
        }
    },
    {
        "visible": true,
        "name": "propCascadeParent",
        "uiType": "propCascadeParent",
        "value": {},
        "dataSource": [],
        "group": "base"
    },
    {
        "visible": false,
        "showCancel": false,
        "name": "alertDialog",
        "uiType": "alertDialog",
        "locale": {
            "title": "Warning"
        },
        "dataSource": [],
        "group": "base"
    },
    {
        "visible": false,
        "name": "dnbSellerTag",
        "uiType": "text",
        "group": "base"
    },
    {
        "important": false,
        "visible": true,
        "name": "description",
        "uiType": "CustomEditor",
        "iframeParams": {
            "itemId": 610887947,
            "sellerId": 6005267952910,
            "sellerName": "KAMMLEEOFFICIAL ",
            "beta": true,
            "cloneProduction": false
        },
        "label": "Main Description",
        "imageBankConfig": {
            "newMediaCenter": true
        },
        "value": {
            "html": {},
            "type": "html"
        },
        "required": false,
        "hasOptions": false,
        "group": "desc",
        "info": {
            "help": "The product description should give the customer useful information about the product to ensure a purchase."
        }
    },
    {
        "important": false,
        "visible": true,
        "name": "enDescription",
        "uiType": "RichText",
        "label": "Product Description",
        "imageBankConfig": {
            "newMediaCenter": true
        },
        "required": true,
        "group": "desc",
        "info": {
            "help": "English description"
        }
    },
    {
        "visible": true,
        "translateUrl": "mtop.lazada.merchant.product.publish.async/?optType=descLocaleSwitch",
        "showCounter": true,
        "name": "shortDescription",
        "uiType": "ListEditor",
        "label": "Highlights",
        "languageList": [
            {
                "label": "English",
                "value": "en_PK"
            },
            {
                "label": "Urdu",
                "value": "ur_PK"
            }
        ],
        "value": [
            {
                "label": "English",
                "key": "en_PK"
            },
            {
                "label": "Urdu",
                "key": "ur_PK"
            }
        ],
        "required": true,
        "group": "desc",
        "info": {
            "help": "Enter a minimum of three short highlights of the product to make the purchase decision easier for the customer. Please format as a bulleted list."
        }
    },
    {
        "visible": true,
        "showCounter": true,
        "name": "packageContent",
        "uiType": "translateInput",
        "multiLanguage": {
            "dialog": {
                "inputConfig": {
                    "maxLength": 255
                },
                "action": {
                    "method": "post",
                    "url": "mtop.lazada.merchant.product.publish.async/?optType=multiLanguageTranslate"
                }
            },
            "iconType": "duoyuyan"
        },
        "label": "What's in the box",
        "illegalPatterns": [
            {
                "pattern": "[]",
                "message": "The input title contains Chinese."
            }
        ],
        "locale": {
            "dialogDesc": "The system will intelligently translate the title you fill into other languages. You can also do manual optimization directly. The manually optimized title will no longer be intelligently translated.",
            "edit": "Setup Multi-Languages",
            "ignore": "Ignore",
            "dialogTitle": "Set up multi-language",
            "dialogCancel": "Cancel",
            "dialogOk": "Save",
            "dialogTranslate": "Translate",
            "type": "globalInput",
            "tips": "Multi-language haven't been added for edited content. Go to \"Set up multi-language\" to synchronize.",
            "setLanguage": "Add Multi-Languages",
            "otherLanguage": "Other languages"
        },
        "value": [
            {
                "label": "Urdu",
                "key": "ur_PK"
            }
        ],
        "required": true,
        "group": "desc",
        "info": {
            "help": "Indicates the items that customer will get when they receive this product. For example, for a smartphone, a customer may get: 1 x Phone, 1 x Cable, 1 x Headset"
        }
    },
    {
        "visible": true,
        "name": "packageBySku",
        "uiType": "Switch",
        "label": "Switch to enter different package dimensions & weight for variations",
        "value": false,
        "group": "package",
        "info": {
            "right": "Switch on if you need different dimension & weight for different product variants"
        }
    },
    {
        "visible": true,
        "hasSaleProps": true,
        "salewithoutpair": true,
        "copyAttributes": [
            "salePrice",
            "skuBarcode",
            "skuPrice"
        ],
        "label": "Price & Stock",
        "locale": {
            "cancel": "Cancel",
            "copyFirst": "Copy the first to the rest",
            "copyFirstStock": "Copy the first stock to the rest only",
            "copyFirstPrice": "Copy the first price to the rest only",
            "addSku": "Add a new SKU",
            "promotionDate": "Promotion Date",
            "availability": "Availability",
            "history": "History",
            "type": "newSku",
            "done": "Apply To All",
            "success": "Success",
            "copySuccess": "Copy Success",
            "calculate": "Calculate",
            "reachMaxMsg": "Most can only add ${maxItems} Skus"
        },
        "canEditSaleProp": true,
        "required": true,
        "sequence": [
            "price",
            "special_price",
            "quantity",
            "SellerSku",
            "skuId",
            "active",
            "combineSkuStatus",
            "auditStatus",
            "invalid",
            "key",
            "images",
            "seller_promotion",
            "oldQuantity"
        ],
        "batchAttributes": [
            "price",
            "quantity",
            "SellerSku"
        ],
        "name": "sku",
        "uiType": "SkuTableV2",
        "rowLocked": false,
        "attributes": {
            "images": {
                "important": false,
                "name": "images",
                "uiType": "hidden",
                "label": "Images",
                "required": false,
                "info": {
                    "help": "Images need to be at least 500 x 500 pixel with a maximum of 2000 x 2000 pixel."
                }
            },
            "quantity": {
                "important": false,
                "min": "0",
                "labelHelp": "Stock here refers to the total stock that seller has in the main warehouse only, including those reserved for campaigns.",
                "name": "quantity",
                "uiType": "NumberPicker",
                "label": "Stock",
                "required": false,
                "info": {}
            },
            "packageWeight": {
                "visible": true,
                "precision": 3,
                "name": "packageWeight",
                "uiType": "PackageWeight",
                "maximum": 300,
                "step": 0.01,
                "label": "Package Weight",
                "units": [
                    {
                        "rate": "1",
                        "label": "kg",
                        "value": "kg"
                    },
                    {
                        "rate": "1000",
                        "label": "g",
                        "value": "gr"
                    }
                ],
                "locale": {
                    "priceUnitText": "kg/piece",
                    "appendexSuffixLabel": "kg",
                    "weightUnitText": {
                        "gr": "g",
                        "kg": "kg"
                    },
                    "customizeWeightText": "Custom weight",
                    "helpInfo": "When you complete fill in self-definition weight of information after, system will in accordance with you of set to calculation total freight ignore Products Packaging size;\r\n\r\nFor volume major in actual weight of products please choose carefully fill in, can calculation the volume heavy after fill in.",
                    "unitPlaceHolder": "Unit",
                    "customizeText4": "pieces each time, and the weight increases.",
                    "type": "logisticsWeightWithUnit",
                    "customizeText1": "Buyers purchase",
                    "customizeText3": "On this basis, buyers buy",
                    "customizeText2": "or less, and calculate shipping cost based on the weight of a single product."
                },
                "minimum": 0.001,
                "required": true
            },
            "combineSkuStatus": {
                "name": "combineSkuStatus",
                "uiType": "hidden"
            },
            "active": {
                "name": "active",
                "uiType": "hidden"
            },
            "SellerSku": {
                "important": false,
                "checkVersion": "V2",
                "name": "SellerSku",
                "uiType": "input",
                "label": "SellerSKU",
                "placeholder": "Seller SKU",
                "checkUrl": "mtop.lazada.merchant.product.publish.async/?optType=sellerSkuCheckAsyncOptV2",
                "required": false,
                "maxLength": 200,
                "info": {
                    "help": "Identifier for a product provieded by the Seller. Product is mandatory for Seller, even when the column \\Mandaroy\\ says something different."
                }
            },
            "oldQuantity": {
                "min": "0",
                "name": "oldQuantity",
                "uiType": "hidden"
            },
            "packageDimensions": {
                "visible": true,
                "precision": 2,
                "lengthMaximum": 300,
                "label": "Package Dimensions(cm): Length * Width * Height",
                "heightMaximum": 300,
                "heightMinimum": 0.01,
                "locale": {
                    "volume": "${volume}cm³ per piece",
                    "length": "Length (cm)",
                    "width": "Width (cm)",
                    "height": "Height (cm)"
                },
                "required": true,
                "widthMinimum": 0.01,
                "name": "packageDimensions",
                "uiType": "PackageVolume",
                "maximum": 300,
                "step": 0.01,
                "widthMaximum": 300,
                "minimum": 0,
                "lengthMinimum": 0.01,
                "info": {
                    "help": "Please fill in the logistics size accurately to avoid the loss of freight caused by filling in the wrong."
                }
            },
            "special_price": {
                "precision": 0,
                "label": "Special Price",
                "discountRateMin": 0.2,
                "specialPriceMsg1": "The special price must be less than the price.",
                "specialPriceMsg2": "The special price must be between $min and $max.",
                "required": false,
                "important": false,
                "priceNotInputMsg": "Firstly please input the price",
                "min": "0",
                "name": "special_price",
                "uiType": "SpecialPrice",
                "discountRateMax": 1,
                "info": {
                    "help": [
                        "Sales Price for a Product for Promotion",
                        ". The rate of the special price to the price must be between 0.20 and 1.00"
                    ]
                }
            },
            "price": {
                "important": false,
                "min": "0",
                "precision": 0,
                "name": "price",
                "uiType": "NumberPicker",
                "label": "Price",
                "required": true,
                "info": {
                    "help": "This is the price, that the customer has to pay for the product. This price includes the taxes. The price is separated with a point delimiter"
                }
            },
            "invalid": {
                "name": "invalid",
                "uiType": "hidden"
            },
            "seller_promotion": {
                "important": false,
                "name": "seller_promotion",
                "uiType": "input",
                "label": "Free Items",
                "required": false,
                "info": {
                    "help": "*Only if applicable* Free merchandise, free items, free products, free gifts, free accessories or advertising gifts that come along with the package."
                }
            },
            "auditStatus": {
                "name": "auditStatus",
                "uiType": "hidden"
            },
            "skuId": {
                "name": "skuId",
                "uiType": "hidden"
            },
            "key": {
                "name": "key",
                "uiType": "hidden"
            }
        },
        "value": [
            {
                "combineSkuStatus": true,
                "active": true,
                "auditStatus": -1,
                "SellerSku": "610887947-1730917029860-0",
                "skuId": 2838397303,
                "props": []
            }
        ],
        "dataSource": [],
        "group": "sale"
    },
    {
        "maxItems": 1,
        "visible": true,
        "bizType": "saleProp",
        "prefix": "custom_",
        "textMaxLength": 50,
        "locale": {
            "cancel": "Cancel",
            "image": "Image",
            "cropFromList": "Crop from uploaded images",
            "maximumImage": "Max {v} images for each variant.",
            "images": "Images",
            "upload": {
                "thumbnail": "Thumbnail",
                "clickHere": "Click here",
                "cropSizeTip": "Dimensions should be between 330x330 and 2000x2000",
                "cropError": "Image clipping failed",
                "duplicate": "Duplicate Pictures",
                "title": "Upload",
                "uploadError": "Upload Error",
                "saveClose": "save and close",
                "addPicture": "Add Picture",
                "mainImage": "Main Image",
                "maxSizeError": "Image size should not exceed 2M. Upload a different image.",
                "uploadTip1": "Drag and drop pictures below to upload.",
                "width": "width",
                "uploadTip4": "See Guidelines here",
                "uploadTip2": "Add at least 3 images of your product from different angles.",
                "uploadTip3": "Maximum 8 pictures. Size between 500x500 and 2000x2000 px. Obscene image is strictly prohibited.",
                "uploadTips": "Drag and drop pictures below to upload. Maximum 8 pictures, size between 500x500 and 2000x2000 px. Obscene image is strictly prohibited.",
                "mediaCenter": "Media Center",
                "toCopy": "to copy images from above SKU.",
                "height": "height"
            },
            "addImage": "Add Image",
            "confirmRemoveImage": "Are you sure to remove image?",
            "type": "lazadaCustomSaleProp",
            "variation": "Variant",
            "useDifferent": "Use a different thumbnail",
            "cropNew": "Upload a new image",
            "tipContent": "Duplicate current value, please modify",
            "view": "Upload Image",
            "manualDeletePrompt": "tr(manual_delete_prompt@customSaleProp)",
            "addVariation": "Add Variation",
            "name": "Variant Name",
            "options": "Total Variants",
            "deletePrompt": "Are you sure want to delete it?",
            "confirmChangeImage": "Are you sure to change image?",
            "tipTitle": "Tips",
            "ok": "Confirm",
            "collapse": "Collapse",
            "inputPlaceholder": "Please type or select"
        },
        "customize": true,
        "required": false,
        "valueMaxLength": 20,
        "imageConfig": {
            "imageMinWidth": 330,
            "imageMaxWidth": 5000,
            "imageLength": 8,
            "imageMinHeight": 330,
            "goldLog": "/LazadaSellerCenter.AddProduct.Image",
            "imageUploadUrl": "/image/upload",
            "newMediaCenter": true,
            "imagePropName": "__images__",
            "imageSize": 2048,
            "imageDownloadUrl": "/product/image/encode",
            "imageMaxHeight": 5000,
            "mediaCenterHost": "https://sellercenter.daraz.pk/mediacenter"
        },
        "valueLimit": 200,
        "hasSort": true,
        "readonly": false,
        "tipForDeleteEnabled": false,
        "name": "customSaleProp",
        "uiType": "customSaleProp",
        "maxPerItem": 200,
        "attributes": [],
        "thumbnailConfig": {
            "imageMaxWidth": 1920,
            "imageMinWidth": 330,
            "imageLength": 1,
            "imageMinHeight": 330,
            "imageUploadUrl": "/image/upload",
            "imagePropName": "color_thumbnail",
            "imageSize": 2048,
            "imageDownloadUrl": "/product/image/encode",
            "imageMaxHeight": 1920,
            "mediaCenterHost": "https://sellercenter.daraz.pk/mediacenter"
        },
        "dataSource": [],
        "value": [],
        "group": "sale",
        "info": {
            "help": "Type and press enter to create, or just to quickly select standard values"
        }
    },
    {
        "important": false,
        "visible": true,
        "name": "warrantyType",
        "uiType": "select",
        "label": "Warranty Type",
        "placeholder": "Select",
        "dataSource": [
            {
                "text": "No Warranty",
                "value": 4498
            },
            {
                "text": "Brand Warranty",
                "value": 265854
            },
            {
                "text": "Seller Warranty",
                "value": 123713018
            }
        ],
        "required": true,
        "group": "package",
        "info": {
            "help": "Warranty_Type"
        }
    },
    {
        "important": false,
        "visible": true,
        "name": "warrantyPeriod",
        "uiType": "select",
        "label": "Warranty Period",
        "placeholder": "Select",
        "dataSource": [
            {
                "text": "1 Month",
                "value": 4463
            },
            {
                "text": "2 Months",
                "value": 4461
            },
            {
                "text": "3 Months",
                "value": 4462
            },
            {
                "text": "4 Months",
                "value": 4460
            },
            {
                "text": "5 Months",
                "value": 4464
            },
            {
                "text": "6 Months",
                "value": 4456
            },
            {
                "text": "7 Months",
                "value": 4472
            },
            {
                "text": "8 Months",
                "value": 4489
            },
            {
                "text": "10 Months",
                "value": 4455
            },
            {
                "text": "11 Months",
                "value": 4478
            },
            {
                "text": "1 Year",
                "value": 4447
            },
            {
                "text": "2 Years",
                "value": 4446
            },
            {
                "text": "3 Years",
                "value": 4448
            },
            {
                "text": "4 Years",
                "value": 4483
            },
            {
                "text": "5 Years",
                "value": 4454
            },
            {
                "text": "6 Years",
                "value": 4497
            },
            {
                "text": "7 Years",
                "value": 4459
            },
            {
                "text": "10 Years",
                "value": 4443
            },
            {
                "text": "Life Time Warranty",
                "value": 4502
            },
            {
                "text": "112",
                "value": 7
            },
            {
                "text": "26",
                "value": 2408
            },
            {
                "text": "42",
                "value": 2409
            },
            {
                "text": "46",
                "value": 2410
            },
            {
                "text": "28",
                "value": 2411
            },
            {
                "text": "44",
                "value": 2419
            },
            {
                "text": "40",
                "value": 2420
            },
            {
                "text": "34",
                "value": 2425
            },
            {
                "text": "38",
                "value": 2426
            },
            {
                "text": "36",
                "value": 2427
            },
            {
                "text": "30",
                "value": 2428
            },
            {
                "text": "32",
                "value": 2433
            },
            {
                "text": "39",
                "value": 2449
            },
            {
                "text": "37",
                "value": 2450
            },
            {
                "text": "24",
                "value": 2451
            },
            {
                "text": "25",
                "value": 2452
            },
            {
                "text": "27",
                "value": 2453
            },
            {
                "text": "54",
                "value": 2457
            },
            {
                "text": "48",
                "value": 2459
            },
            {
                "text": "29",
                "value": 2460
            },
            {
                "text": "31",
                "value": 2461
            },
            {
                "text": "33",
                "value": 2462
            },
            {
                "text": "52",
                "value": 2463
            },
            {
                "text": "35",
                "value": 2466
            },
            {
                "text": "45",
                "value": 2469
            },
            {
                "text": "41",
                "value": 2473
            },
            {
                "text": "43",
                "value": 2479
            },
            {
                "text": "22",
                "value": 2480
            },
            {
                "text": "50",
                "value": 2483
            },
            {
                "text": "6",
                "value": 2486
            },
            {
                "text": "12",
                "value": 2488
            },
            {
                "text": "13",
                "value": 2489
            },
            {
                "text": "5",
                "value": 2490
            },
            {
                "text": "11",
                "value": 2493
            },
            {
                "text": "19",
                "value": 2501
            },
            {
                "text": "7",
                "value": 2503
            },
            {
                "text": "9",
                "value": 2504
            },
            {
                "text": "10",
                "value": 2510
            },
            {
                "text": "8",
                "value": 2512
            },
            {
                "text": "14",
                "value": 2538
            },
            {
                "text": "21",
                "value": 2546
            },
            {
                "text": "20",
                "value": 2553
            },
            {
                "text": "51",
                "value": 2596
            },
            {
                "text": "2",
                "value": 2679
            },
            {
                "text": "3",
                "value": 2682
            },
            {
                "text": "17",
                "value": 2732
            },
            {
                "text": "15",
                "value": 2737
            },
            {
                "text": "16",
                "value": 2741
            },
            {
                "text": "4",
                "value": 2742
            },
            {
                "text": "1",
                "value": 3918
            },
            {
                "text": "18",
                "value": 4453
            },
            {
                "text": "25 Years",
                "value": 4466
            },
            {
                "text": "9 Months",
                "value": 4507
            },
            {
                "text": "23",
                "value": 19980
            },
            {
                "text": "47",
                "value": 20549
            },
            {
                "text": "49",
                "value": 21424
            },
            {
                "text": "55",
                "value": 21426
            },
            {
                "text": "95",
                "value": 21427
            },
            {
                "text": "86",
                "value": 21428
            },
            {
                "text": "82",
                "value": 21429
            },
            {
                "text": "77",
                "value": 21430
            },
            {
                "text": "72",
                "value": 21431
            },
            {
                "text": "62",
                "value": 21432
            },
            {
                "text": "58",
                "value": 21435
            },
            {
                "text": "67",
                "value": 21436
            },
            {
                "text": "81",
                "value": 21438
            },
            {
                "text": "98",
                "value": 21519
            },
            {
                "text": "70",
                "value": 21520
            },
            {
                "text": "65",
                "value": 21521
            },
            {
                "text": "60",
                "value": 21522
            },
            {
                "text": "88",
                "value": 21523
            },
            {
                "text": "80",
                "value": 21524
            },
            {
                "text": "105",
                "value": 21525
            },
            {
                "text": "90",
                "value": 21527
            },
            {
                "text": "75",
                "value": 21530
            },
            {
                "text": "78",
                "value": 21533
            },
            {
                "text": "79",
                "value": 21534
            },
            {
                "text": "85",
                "value": 21536
            },
            {
                "text": "84",
                "value": 21537
            },
            {
                "text": "8 Years",
                "value": 23160
            },
            {
                "text": "61",
                "value": 23547
            },
            {
                "text": "N/A",
                "value": 53035
            },
            {
                "text": "12 Years",
                "value": 63196
            },
            {
                "text": "15 Years",
                "value": 63197
            },
            {
                "text": "18 Months",
                "value": 64235
            },
            {
                "text": "107",
                "value": 72501
            },
            {
                "text": "56",
                "value": 78379
            },
            {
                "text": "30 Years",
                "value": 116410
            },
            {
                "text": "64",
                "value": 130165
            },
            {
                "text": "74",
                "value": 130166
            },
            {
                "text": "66",
                "value": 130167
            },
            {
                "text": "76",
                "value": 130168
            },
            {
                "text": "68",
                "value": 130169
            },
            {
                "text": "120",
                "value": 159097
            },
            {
                "text": "110",
                "value": 159098
            },
            {
                "text": "115",
                "value": 159099
            },
            {
                "text": "100",
                "value": 159120
            },
            {
                "text": "57",
                "value": 159121
            },
            {
                "text": "59",
                "value": 159122
            },
            {
                "text": "99",
                "value": 159470
            },
            {
                "text": "53",
                "value": 163074
            },
            {
                "text": "63",
                "value": 163075
            },
            {
                "text": "69",
                "value": 163076
            },
            {
                "text": "71",
                "value": 163077
            },
            {
                "text": "73",
                "value": 163078
            },
            {
                "text": "83",
                "value": 163079
            },
            {
                "text": "87",
                "value": 163080
            },
            {
                "text": "89",
                "value": 163081
            },
            {
                "text": "91",
                "value": 163082
            },
            {
                "text": "92",
                "value": 163083
            },
            {
                "text": "93",
                "value": 163084
            },
            {
                "text": "94",
                "value": 163085
            },
            {
                "text": "96",
                "value": 163086
            },
            {
                "text": "97",
                "value": 163087
            },
            {
                "text": "101",
                "value": 163088
            },
            {
                "text": "102",
                "value": 163089
            },
            {
                "text": "103",
                "value": 163090
            },
            {
                "text": "104",
                "value": 163091
            },
            {
                "text": "106",
                "value": 163092
            },
            {
                "text": "108",
                "value": 163093
            },
            {
                "text": "109",
                "value": 163094
            },
            {
                "text": "111",
                "value": 163095
            },
            {
                "text": "113",
                "value": 163096
            },
            {
                "text": "114",
                "value": 163097
            },
            {
                "text": "116",
                "value": 163098
            },
            {
                "text": "117",
                "value": 163099
            },
            {
                "text": "118",
                "value": 163100
            },
            {
                "text": "119",
                "value": 163101
            },
            {
                "text": "15 Months",
                "value": 265703
            },
            {
                "text": "9 Years",
                "value": 265705
            },
            {
                "text": "18 Years",
                "value": 265708
            },
            {
                "text": "20 Years",
                "value": 265759
            },
            {
                "text": "11 Years",
                "value": 265773
            },
            {
                "text": "13 Years",
                "value": 265774
            },
            {
                "text": "14 Years",
                "value": 265775
            },
            {
                "text": "16 Years",
                "value": 265776
            },
            {
                "text": "17 Years",
                "value": 265777
            },
            {
                "text": "19 Years",
                "value": 265778
            },
            {
                "text": "21 Years",
                "value": 265779
            },
            {
                "text": "22 Years",
                "value": 265780
            },
            {
                "text": "23 Years",
                "value": 265781
            },
            {
                "text": "24 Years",
                "value": 265782
            },
            {
                "text": "26 Years",
                "value": 265783
            },
            {
                "text": "27 Years",
                "value": 265784
            },
            {
                "text": "28 Years",
                "value": 265785
            },
            {
                "text": "29 Years",
                "value": 265786
            }
        ],
        "required": false,
        "group": "package",
        "info": {
            "help": "Please select a warranty duration for your product."
        }
    },
    {
        "visible": true,
        "showCounter": true,
        "name": "warrantyPolicy",
        "uiType": "translateInput",
        "multiLanguage": {
            "dialog": {
                "inputConfig": {
                    "maxLength": 255
                },
                "action": {
                    "method": "post",
                    "url": "mtop.lazada.merchant.product.publish.async/?optType=multiLanguageTranslate"
                }
            },
            "iconType": "duoyuyan"
        },
        "label": "Warranty Policy",
        "illegalPatterns": [
            {
                "pattern": "[]",
                "message": "The input title contains Chinese."
            }
        ],
        "locale": {
            "dialogDesc": "The system will intelligently translate the title you fill into other languages. You can also do manual optimization directly. The manually optimized title will no longer be intelligently translated.",
            "edit": "Setup Multi-Languages",
            "ignore": "Ignore",
            "dialogTitle": "Set up multi-language",
            "dialogCancel": "Cancel",
            "dialogOk": "Save",
            "dialogTranslate": "Translate",
            "type": "globalInput",
            "tips": "Multi-language haven't been added for edited content. Go to \"Set up multi-language\" to synchronize.",
            "setLanguage": "Add Multi-Languages",
            "otherLanguage": "Other languages"
        },
        "value": [
            {
                "label": "English",
                "key": "en_US"
            },
            {
                "label": "Urdu",
                "key": "ur_PK"
            }
        ],
        "required": false,
        "group": "package",
        "info": {
            "help": "Please provide more details about your warranty policy such as documentation required, warranty locations/address, etc."
        }
    },
    {
        "visible": true,
        "precision": 3,
        "label": "Package Weight",
        "units": [
            {
                "rate": "1",
                "value": "kg"
            },
            {
                "rate": "1000",
                "label": "g",
                "value": "gr"
            }
        ],
        "locale": {
            "priceUnitText": "kg/piece",
            "appendexSuffixLabel": "kg",
            "weightUnitText": {
                "gr": "g",
                "kg": "kg"
            },
            "customizeWeightText": "Custom weight",
            "helpInfo": "When you complete fill in self-definition weight of information after, system will in accordance with you of set to calculation total freight ignore Products Packaging size;\r\n\r\nFor volume major in actual weight of products please choose carefully fill in, can calculation the volume heavy after fill in.",
            "unitPlaceHolder": "Unit",
            "customizeText4": "pieces each time, and the weight increases.",
            "type": "logisticsWeightWithUnit",
            "customizeText1": "Buyers purchase",
            "customizeText3": "On this basis, buyers buy",
            "customizeText2": "or less, and calculate shipping cost based on the weight of a single product."
        },
        "required": true,
        "name": "logisticsWeight",
        "uiType": "PackageWeight",
        "maximum": 300,
        "step": 0.01,
        "minimum": 0.001,
        "value": {
            "unitName": "kg",
            "showCustomWeight": false,
            "openCustomWeight": false
        },
        "group": "package",
        "info": {
            "help": "Weight and packaging size: Please fill in the weight including packaging. Inaccurate information will results in extra shipping costs and failed shipping."
        }
    },
    {
        "visible": true,
        "precision": 2,
        "lengthMaximum": 300,
        "label": "Package Length(cm) * Width(cm) * Height(cm)",
        "heightMaximum": 300,
        "heightMinimum": 0.01,
        "locale": {
            "volume": "${volume}cm³ per piece",
            "length": "Length (cm)",
            "width": "Width (cm)",
            "height": "Height (cm)",
            "topHelp": "<div style=\"width:400px;padding:20px;text-align:center;font-size:14px;\"><div style=\"background:#F5F8FD;padding:12px;margin-bottom:12px;text-align:left;\">Please <b>include the packaging materials</b> to be used for shipment while entering the package weight and dimensions. Do note that inaccurate package dimensions may result in additional shipping charges or failed delivery.</div><img src=\"https://img.alicdn.com/imgextra/i1/O1CN01WkMCp91LTuAtBTEZt_!!6000000001301-2-tps-1688-1316.png\" width=\"258\"/></div>"
        },
        "required": true,
        "widthMinimum": 0.01,
        "name": "logisticsSize",
        "uiType": "PackageVolume",
        "maximum": 300,
        "step": 0.01,
        "widthMaximum": 300,
        "minimum": 0,
        "lengthMinimum": 0.01,
        "group": "package",
        "info": {
            "help": "Please fill in the logistics size accurately to avoid the loss of freight caused by filling in the wrong.",
            "top": "How to measure my package dimensions?"
        }
    },
    {
        "visible": false,
        "name": "shipping",
        "uiType": "ShippingFee",
        "attributes": [
            {
                "name": "deliveryByLazada",
                "subscribeTip": "The default Standard delivery will apply to this product."
            }
        ],
        "label": "Choose Shipping Options",
        "dataSource": [
            {
                "text": "Delivered By Daraz",
                "value": "deliveryByLazada"
            },
            {
                "disabled": true,
                "tip": "Only available for sellers who pass our requirements. Please Register to be able to use Delivered by Seller option.",
                "text": "Delivered By Seller",
                "value": "deliveryBySeller",
                "info": "Only available for sellers who pass our requirements"
            }
        ],
        "value": {
            "deliveryOption": "deliveryByLazada"
        },
        "group": "package",
        "info": {
            "top": "Standard Delivery is the default shipping option. Please note that shipping settings below will be applicable for this product only and the actual shipping option is also based on your warehouse address. The options disabled by you will not be used to deliver this product."
        }
    },
    {
        "important": false,
        "visible": true,
        "name": "radioDangerousGoods",
        "uiType": "RadioGroup",
        "multiple": true,
        "label": "Dangerous Goods",
        "dataSource": [
            {
                "text": "None",
                "value": 19955
            },
            {
                "text": "Contains battery / flammables / liquid",
                "value": 12893
            }
        ],
        "value": 19955,
        "required": false,
        "group": "package",
        "info": {
            "help": "Please indicate if your product contains battery, liquid or other dangerous components so as to ensure smooth logistics process, multiple selection is available."
        }
    },
    {
        "visible": true,
        "name": "indexTab",
        "group": "layout"
    },
    {
        "visible": true,
        "name": "basicBlock",
        "group": "layout"
    },
    {
        "visible": true,
        "name": "detailBlock",
        "group": "layout"
    },
    {
        "visible": true,
        "name": "skuBlock",
        "group": "layout"
    },
    {
        "visible": true,
        "name": "warrantyBlock",
        "group": "layout"
    },
    {
        "visible": false,
        "name": "eticketBlock",
        "group": "layout"
    },
    {
        "visible": false,
        "name": "shopee_id",
        "group": "layout"
    },
    {
        "visible": true,
        "name": "productQuality",
        "uiType": "ProductQuality",
        "locale": {
            "qualified": "Qualified",
            "top": "Top",
            "low": "Low",
            "excellent": "Excellent",
            "poor": "Poor",
            "showMore": "More",
            "tip": "tr(data.card_feedback_tip.lazada)",
            "recommend": "Recommend for you",
            "medium": "To be Improved",
            "type": "lzdProductQualityLocaleModel",
            "title": "Content Score",
            "showLess": "Hide"
        },
        "required": false,
        "group": "layout"
    },
    {
        "visible": true,
        "name": "termsConditions",
        "uiType": "catProp",
        "label": "Terms & Conditions",
        "locale": {
            "clear": "Clear all",
            "type": "catPropertyLocaleModel"
        },
        "hideSecondaryProp": true,
        "dataSource": [],
        "value": {},
        "required": false,
        "group": "termcondition",
        "info": {
            "help": "Product specification determines buyers' understanding of product features and their purchase decision. Fill in both key and supporting specification attributes to increase your product exposure.",
            "top": "Boost your item's searchability by filling-up the Key Product Information marked with KEY. The more you fill-up, the easier for buyers to find your product."
        }
    },
    {
        "visible": false,
        "name": "newLorikeetGray",
        "uiType": "text",
        "value": 1,
        "group": "desc"
    }
]

export default defaultForms;